<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="title" placeholder="请输入名称" @keyup.enter.native="getList(0, 1)" clearable></el-input>
            </div>
            <div class="main_header_item" v-if="postList.role">
                <el-input v-model="uri" placeholder="请输入接口路径" @keyup.enter.native="getList(0, 1)" clearable></el-input>
            </div>
            <div class="main_header_item" v-if="postList.router">
                <el-input v-model="index" placeholder="请输入路由" @keyup.enter.native="getList(0, 1)" clearable></el-input>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <el-select filterable v-model="status" placeholder="请选择状态" clearable>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.value">
                <el-cascader
                    v-model="value"
                    :options="option"
                    placeholder="请选择上级权限"
                    :props="{
                        checkStrictly: true,
                        value: 'id',
                        label: 'title',
                        children: 'subs'
                    }"
                    clearable
                    filterable
                    @change="handleChange"
                ></el-cascader>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="mini" plain icon="el-icon-plus" @click="addRole(2)" v-if="postList.addBtn">新增</el-button>
                <el-button size="mini" plain icon="el-icon-plus" @click="allDelate" :loading="btnLoading" v-if="postList.delateBtn"
                    >批量删除</el-button
                >
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                class="permission"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
                @selection-change="selectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="item.prop == 'icon'">
                                <i :class="scope.row.icon"></i>
                            </div>
                            <div v-else-if="item.prop == 'type'">
                                <span v-if="scope.row.type == 1">一级菜单</span>
                                <span type="success" v-if="scope.row.type == 2">二级菜单</span>
                                <span type="warning" v-if="scope.row.type == 3">三级菜单</span>
                                <span type="info" v-if="scope.row.type == 4">功能权限</span>
                            </div>
                            <div v-else-if="item.prop == 'status'">
                                <span v-if="scope.row.status == 1" style="color: green">启用</span>
                                <span v-else style="color: red">禁用</span>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.$index, scope.row, 1)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.$index, scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
            <!-- 弹出框 新增 编辑 -->
            <el-dialog
                :close-on-click-modal="false"
                v-dialogDrag
                :title="header_title"
                :visible.sync="dialogVisible"
                width="600px"
                :before-close="handleClose"
            >
                <p style="color: red; margin: -15px 0 10px 30px; font-size: 15px" v-show="add_show">
                    注意：上级权限、类型 一旦保存后就不允许修改，请谨慎填写！
                </p>
                <p style="color: red; margin: -15px 0 10px 30px; font-size: 15px" v-show="edit_show">
                    注意：上级权限、类型 不允许修改，请删除后重新新增！
                </p>
                <el-form ref="form" :model="form" label-width="100px" :rules="rules">
                    <el-form-item label="名称" prop="title">
                        <el-input v-model="form.title" style="width: 100%" clearable placeholder="请输入名称"></el-input>
                    </el-form-item>
                    <el-form-item label="上级权限" v-if="add_show" prop="value">
                        <el-cascader
                            style="width: 100%"
                            v-model="form.value"
                            :options="option"
                            :props="{
                                checkStrictly: true,
                                value: 'id',
                                label: 'title',
                                children: 'subs'
                            }"
                            clearable
                            @change="dialogHandleChange"
                            ref="cascaderInesrt"
                            :disabled="cas_disabled"
                            placeholder="请选择上级权限"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="上级权限" v-if="edit_show" prop="pid">
                        <el-cascader
                            v-model="form.pid"
                            :options="option"
                            :props="{
                                checkStrictly: true,
                                value: 'id',
                                label: 'title',
                                children: 'subs'
                            }"
                            clearable
                            @change="dialogHandleChange"
                            ref="cascaderInesrt"
                            :disabled="cas_disabled"
                            placeholder="请选择上级权限"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="类型" prop="type">
                        <el-radio-group v-model="form.type">
                            <el-radio :label="1" :disabled="isDisabled[1]">一级菜单</el-radio>
                            <el-radio :label="2" :disabled="isDisabled[2]">二级菜单</el-radio>
                            <el-radio :label="3" :disabled="isDisabled[3]">三级菜单</el-radio>
                            <el-radio :label="4" :disabled="isDisabled[4]">功能</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="icon图标" prop="icon">
                        <el-input placeholder="请输入icon图标" v-model="form.icon" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="路由" prop="index">
                        <el-input v-model="form.index" clearable placeholder="请输入路由"></el-input>
                    </el-form-item>
                    <el-form-item label="接口路径" prop="uri">
                        <el-input v-model="form.uri" clearable placeholder="请输入接口路径"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input-number v-model="form.sort" label="描述文字"></el-input-number>
                        <span style="margin-left: 15px; color: red">默认255，越大越靠前</span>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="1">启用</el-radio>
                            <el-radio :label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancle">取 消</el-button>
                    <el-button type="primary" @click="okData('form')" :loading="loading">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'authorityComponent',
    data() {
        return {
            draggable: {
                data_name: 'permission'
            },
            down_loading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            rules: {
                title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                sort: [{ required: true, message: '请选择排序', trigger: 'blur' }],
                uri: [{ required: true, message: '请输入接口路径', trigger: 'blur' }]
            },
            uri: '',
            index: '',
            authority: true,
            id: '',
            ok_type: '',
            isDisabled: {
                1: true,
                2: true,
                3: true,
                4: true
            },
            cas_disabled: false,
            pid: '',
            add_show: false,
            edit_show: false,
            value: '',
            header_title: '',
            option: [],
            show: false,
            form: {
                title: '',
                value: '',
                type: '1',
                icon: '',
                index: '',
                uri: '/admin',
                sort: 255,
                status: ''
            },
            dialogVisible: false,
            listLoading: false, //加载数据中
            tableData: [],
            title: '', //用户名
            phone: '', //手机号
            status: '',
            options: [
                {
                    value: '-1',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '启用'
                },
                {
                    value: '0',
                    label: '禁用'
                }
            ],
            selected: [],
            btnLoading: false
        };
    },
    props: {
        postList: {
            type: Object
        }
    },

    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['authority_params']) {
                this.page = paramsList['authority_params'].page;
                this.row = paramsList['authority_params'].row;
                this.parent_rid = paramsList['authority_params'].parent_rid;
                // this.data_name = paramsList['authority_params'].data_name;
                // this.sort = paramsList['authority_params'].sort;
                this.pid = paramsList['authority_params'].pid;
                this.index = paramsList['authority_params'].index;
                this.uri = paramsList['authority_params'].uri;
                this.value = paramsList['authority_params'].value;
                this.status = paramsList['authority_params'].status;
                this.title = paramsList['authority_params'].title;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getPermission(); //获取权限下拉列表
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                this.getList(0); //获取列表
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('permission', this, 1);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).permission;
        },
        handleChange(value) {
            if (value.length == 1) {
                this.pid = value[0];
            } else {
                this.pid = value[1];
            }
        },
        //新增权限
        addRole(type) {
            this.authority = true;
            this.form = {
                title: '',
                pid: '',
                value: '',
                type: 1,
                icon: '',
                index: '',
                uri: '/admin',
                sort: 255,
                status: 1
            };
            this.ok_type = type;
            this.cas_disabled = false;
            this.add_show = true;
            this.edit_show = false;
            this.header_title = '新增';
            this.dialogVisible = true;
        },
        //批量删除
        allDelate() {
            let idList = this.selected.map((item) => item.id);
            if (this.selected.length == 0) {
                this.$message({
                    type: 'warning',
                    message: '还未选择数据'
                });
            } else {
                this.btnLoading = true;
                let num = idList.length;
                let messages = '此操作将删除' + num + '条权限，是否继续?';
                this.$msgbox(messages, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        let params = {
                            ids: idList
                        };
                        this.$api
                            .permissionBatchDelete(params)
                            .then((res) => {
                                this.btnLoading = false;
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getList(0);
                                }
                            })
                            .catch((error) => {
                                this.btnLoading = false;
                            });
                    })
                    .catch(() => {
                        this.btnLoading = false;
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        checkSelectable(row) {
            return row.status === 1;
        },
        handleClose() {
            this.dialogVisible = false;
            this.form = {
                title: '',
                pid: '',
                value: '',
                type: 1,
                icon: '',
                index: '',
                uri: '/admin',
                sort: 255,
                status: 1
            };
            this.isDisabled = {
                1: true,
                2: true,
                3: true,
                4: true
            };
            this.$refs['form'].resetFields();
        },
        //提交新增/编辑修改
        okData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    if (this.ok_type == 1) {
                        const paramsList = {
                            title: this.form.title,
                            id: this.id,
                            icon: this.form.icon,
                            index: this.form.index,
                            uri: this.form.uri,
                            sort: this.form.sort,
                            status: this.form.status
                        };
                        this.permission(paramsList, 2);
                    } else {
                        if (this.form.value) {
                            if (this.form.value.length == 1) {
                                this.pid = this.form.value[0];
                            } else {
                                this.pid = this.form.value[this.form.value.length - 1];
                            }
                            const paramsList = {
                                title: this.form.title,
                                pid: this.pid,
                                type: this.form.type,
                                icon: this.form.icon,
                                index: this.form.index,
                                uri: this.form.uri,
                                sort: this.form.sort,
                                status: this.form.status
                            };
                            this.permission(paramsList, 1);
                        } else {
                            const paramsList = {
                                title: this.form.title,
                                pid: 0,
                                type: this.form.type,
                                icon: this.form.icon,
                                index: this.form.index,
                                uri: this.form.uri,
                                sort: this.form.sort,
                                status: this.form.status
                            };
                            this.permission(paramsList, 1);
                        }
                    }
                } else {
                    return false;
                }
            });
        },
        //新增、编辑权限
        permission(params, type) {
            if (type == 1) {
                this.$api
                    .permissionInsert(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            });
                            this.form = {
                                title: '',
                                value: '',
                                type: '1',
                                icon: '',
                                index: '',
                                uri: '/admin',
                                sort: 255,
                                status: ''
                            };
                            this.isDisabled = {
                                1: true,
                                2: true,
                                3: true,
                                4: true
                            };
                            this.dialogVisible = false;
                            this.show = false;
                            this.getList(0); //获取权限列表
                            this.getPermission(); //权限下拉列表
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else if (type == 2) {
                this.$api
                    .permissionUpdate(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '修改成功'
                            });
                            this.form.title = '';
                            this.form.value = '1';
                            this.form.type = '';
                            this.form.icon = '/admin';
                            this.form.index = '';
                            this.form.uri = '';
                            this.form.sort = '255';
                            this.form.status = '';
                            this.isDisabled = {
                                1: true,
                                2: true,
                                3: true,
                                4: true
                            };
                            this.ok_type = '';
                            this.dialogVisible = false;
                            this.show = false;
                            this.getList(0); //获取权限列表
                            this.getPermission(); //权限下拉列表
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            }
        },
        //点击取消
        cancle() {
            this.form = {
                title: '',
                pid: '',
                value: '',
                type: '1',
                icon: '',
                index: '',
                uri: '/admin',
                sort: 255,
                status: ''
            };
            this.isDisabled = {
                1: true,
                2: true,
                3: true,
                4: true
            };
            this.dialogVisible = false;
            this.$refs['form'].resetFields();
        },
        dialogHandleChange(value) {
            if (value.length == 0) {
                this.form.pid = 0;
            } else {
                this.form.pid = value[value.length - 1];
            }
            this.isDisabled = {
                1: true,
                2: true,
                3: true,
                4: true
            };
            var nodeData = this.$refs.cascaderInesrt.getCheckedNodes();
            if (nodeData.length != 0) {
                var type = nodeData[0]['data']['type'];
                if (type == 1) {
                    this.isDisabled[2] = false;
                    this.isDisabled[4] = false;
                    this.form.type = 2;
                } else if (type == 2) {
                    this.isDisabled[3] = false;
                    this.isDisabled[4] = false;
                    this.form.type = 4;
                }
            }
        },
        //获取权限下拉列表
        getPermission() {
            let params = {};
            this.$api
                .getPermissionDropDown(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.option = res.data;
                    }
                })
                .catch((error) => {});
        },
        //前往编辑页面
        editDetails(index, row, type) {
            this.id = row.id;
            this.cas_disabled = true;
            this.ok_type = type;
            this.edit_show = true;
            this.add_show = false;
            this.header_title = '编辑';
            this.dialogVisible = true;
            this.show = true;
            this.form.title = row.title;
            if (row.pid) {
                this.form.pid = row.pid;
            }
            this.form.type = row.type;
            this.form.icon = row.icon;
            this.form.index = row.index;
            this.form.uri = row.uri;
            this.form.sort = row.sort;
            this.form.status = row.status;
        },
        //删除当前行
        amend(index, row) {
            let row_title = '确定要删除[' + row.title + ']吗?';
            this.$msgbox(row_title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    let params = {
                        ids: [row.id]
                    };
                    this.$api
                        .permissionBatchDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }

            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['authority_params']) {
                    newParamsList['authority_params'].data_name = val.prop;
                    newParamsList['authority_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                title: this.title,
                status: this.status,
                pid: this.pid,
                value: this.value,
                index: this.index,
                sort: [this.data_name, this.sort],
                uri: this.uri,
                is_export: type_data
            };

            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['authority_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .permissionLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;

                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['authority_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;

            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['authority_params']) {
                    newParamsList['authority_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        title: this.title,
                        status: this.status,
                        pid: this.pid,
                        value: this.value,
                        index: this.index,
                        sort: [this.data_name, this.sort],
                        uri: this.uri
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['authority_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;

            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['authority_params']) {
                    newParamsList['authority_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        title: this.title,
                        status: this.status,
                        pid: this.pid,
                        value: this.value,
                        index: this.index,
                        sort: [this.data_name, this.sort],
                        uri: this.uri
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['authority_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.title = '';
            this.status = '';
            this.value = '';
            this.uri = '';
            this.index = '';
            this.pid = '';
            this.sort = '';
            this.data_name = '';
            this.parent_rid = '';
            this.page = 1;
            this.row = 25;

            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                title: '',
                status: '',
                value: '',
                uri: '',
                index: '',
                pid: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['authority_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
.el-form-item /deep/ .el-form-item__label {
    width: 180px;
}
</style>